import * as Constants from "../constants";
import flatten from "lodash/flatten";

const initialState = {
  data: {},
  action: {},
  loading: false,
  orderMedicinesMap: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case Constants.FETCH_ORDER_START:
      return Object.assign({}, state, { action, loading: true });
    case Constants.FETCH_ORDER_SUCCESS: {
      const { data } = action;

      const orderMedicinesMap = { ...state.orderMedicinesMap };

      if (data && data.shipments) {
        const items = [];
        data.shipments.forEach((shipment) => {
          items.push(shipment.items);
        });
        orderMedicinesMap[data.id] = flatten(items);
      } else {
        orderMedicinesMap[data.data.id] = [...data.data.products];
      }

      return Object.assign({}, state, {
        data: action.data,
        orderMedicinesMap,
        action,
        loading: false,
      });
    }
    case Constants.FETCH_ORDER_FAILURE:
      return Object.assign({}, state, {
        data: action.data,
        action,
        loading: false,
      });

    default:
      return { ...state };
  }
}
